import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center flex flex-col items-center" }
const _hoisted_2 = { class: "mt-8 md:mt-16" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-2 gap-6 my-16 justify-items-center w-full sm:w-4/5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_addon_card = _resolveComponent("addon-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Dodatki")), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_addon_card, {
          key: item,
          itemData: item,
          addon: true
        }, null, 8, ["itemData"]))
      }), 128))
    ])
  ]))
}